import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useAuthContext } from "components/context/authContext";
import Button from "components/button/default";
import ResetPwdModal from "components/modal/resetpwd";
import { alertControl } from "util/commAction";
import "./login.scss";

type IProps = {
  styles: string;
  emlId: string;
  lgnPwd: string;
  handleChange(name: string, value: string): void;
  handleLogin(): void;
};

export default function Login({
  styles,
  emlId,
  lgnPwd,
  handleChange,
  handleLogin,
}: IProps) {
  const { t } = useTranslation();
  const { userInf, setUserInf } = useAuthContext();

  const [showPwd, setShowPwd] = useState(false);

  return (
    <div className={styles}>
      <h1>{t("ttl_lgi")}</h1>
      <div className="">
        <input
          type="text"
          className="mb-[12px]"
          placeholder={t("txt_eml_id_cmm")}
          name="emlId"
          value={emlId}
          required
          onChange={(e) => {
            handleChange("emlId", e.currentTarget.value);
          }}
        />
        <input
          type={showPwd ? "text" : "password"}
          id="lgnPwd"
          className="mb-[12px]"
          placeholder={t("txt_pwd_cmm")}
          name={"lgnPwd"}
          value={lgnPwd}
          required
          onChange={(e) => {
            handleChange("lgnPwd", e.currentTarget.value);
          }}
        />
        <label
          htmlFor="lgnPwd"
          className={showPwd ? "on" : ""}
          onClick={() => setShowPwd(!showPwd)}
        ></label>
        <ul className="flex justify-between px-[18px] md:px-[41px]">
          <li>
            <input
              type="checkbox"
              name="rm_eml"
              id="rm_eml"
              defaultChecked={!!localStorage.getItem("emlId")}
              onChange={(e) => {
                if (!emlId) {
                  alertControl({
                    isOpen: true,
                    inner: t("alr_insert_pwd"),
                  });
                  e.preventDefault();
                  e.currentTarget.checked = false;
                  return;
                }
                const checked = e.currentTarget.checked;
                if (checked) {
                  setUserInf({
                    ...userInf,
                    emlId,
                  });
                  localStorage.setItem("emlId", emlId + "");
                }
                if (!checked) {
                  localStorage.removeItem("emlId");
                }
              }}
            />
            <label htmlFor="rm_eml" className="">
              {t("chckbx_lbl_rm_eml")}
            </label>
          </li>
          <li
            onClick={() => {
              alertControl({
                isOpen: true,
                chk_btn: false,
                innerHtml: <ResetPwdModal />,
              });
            }}
          >
            {t("btn_fnd_pss")}
            {/* <Link to="/resetpwd">{t("btn_fnd_pss")}</Link> */}
          </li>
        </ul>
        <Button
          text={t("btn_lgi")}
          styels="w-full"
          disabled={!emlId && !lgnPwd}
          onClick={handleLogin}
        />

        <p>
          {t("dscrp_no_mem")}&nbsp;&nbsp;
          <b>
            <Link to="/join">{t("lnk_join")}</Link>
          </b>
        </p>
      </div>
      <div className="btn-wrap">
        <Button
          text={"Apple" + " " + t("btn_id_lgi")}
          styels="apple"
          onClick={() => {}}
        />
        <Button
          text={"Goole" + " " + t("btn_id_lgi")}
          styels="google"
          onClick={() => {}}
        />
      </div>
      {/* <ResetPwdModal isOpen={isOpen} setIsOpen={setIsOpen} /> */}
    </div>
  );
}
